import { Component } from '@angular/core';

@Component({
  selector: 'app-finish-box',
  imports: [],
  templateUrl: './finish-box.component.html',
  styleUrl: './finish-box.component.css'
})
export class FinishBoxComponent {

}
